import EmptyableCard from '../../../../components/Card/EmptyableCard';
import LocumContactsCard from '../../../../components/Card/LocumContactCard';

const DummyPostedJobs = [
  {
    imgSrc: '/static/gif/happyAnimal.gif',
    title: 'Dr. Kate Alabi',
    description: 'kateala23@gmail.com',
    contact: 'Contact Locum',
  },
  {
    imgSrc: '/static/gif/happyAnimal.gif',
    title: 'Dr. Daniel Olawande',
    description: 'daniel23@gmail.com',
    contact: 'Contact Locum',
  },
  {
    imgSrc: '/static/gif/happyAnimal.gif',
    title: 'Dr. Daniel Olawande',
    description: 'daniel23@gmail.com',
    contact: 'Contact Locum',
  },
  {
    imgSrc: '/static/gif/happyAnimal.gif',
    title: 'Dr. Daniel Olawande',
    description: 'daniel23@gmail.com',
    contact: 'Contact Locum',
  },
];
const LocumContacts = () => {
  return (
    <EmptyableCard
      label="Locum Contacts"
      viewAllClick={() => {}}
      emptyViewNote="You currently do not have any listing,
verify your account to get started"
    >
      {DummyPostedJobs.map((data, index) => (
        <LocumContactsCard
          key={index}
          imgSrc={data.imgSrc}
          title={data.title}
          email={data.description}
          contact={data.contact}
        />
      ))}
    </EmptyableCard>
  );
};

export default LocumContacts;
